// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label-container[data-v-acaa15da]{box-sizing:border-box;border:1px solid #4a89dc;border-radius:2px;background-color:#4a89dc;display:flex;justify-content:center;align-items:center;padding:2px 8px;display:inline-block}.label-container-text[data-v-acaa15da]{color:#fff;font-size:12px;line-height:18px}", ""]);
// Exports
module.exports = exports;
